"use client";

import React, { useState } from "react";
import { cn } from "@repo/utils/cn";

export interface TooltipProps {
  content: string;
  children: React.ReactNode;
  className?: string;
  tooltipClassName?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ 
  content, 
  children, 
  className,
  tooltipClassName 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className={cn("uipm:relative uipm:inline-block", className)}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className={cn(
          "uipm:absolute uipm:z-50",
          "uipm:bottom-full uipm:left-1/2 uipm:-translate-x-1/2",
          "uipm:mb-[8px]",
          "uipm:pointer-events-none",
          "uipm:transition-opacity uipm:duration-200",
          isVisible ? "uipm:opacity-100" : "uipm:opacity-0"
        )}>
          <div 
            className={cn(
              "uipm:relative",
              "uipm:px-4 uipm:py-2 uipm:min-w-[200px] uipm:max-w-[280px]",
              "uipm:bg-[#2C2C2C] uipm:rounded-[4px]",
              "uipm:text-[13px] uipm:leading-[18px] uipm:text-white",
              "uipm:font-['Inter'] uipm:font-normal",
              "uipm:whitespace-normal",
              tooltipClassName
            )}
          >
            {content}
            <svg 
              className="uipm:absolute uipm:top-full uipm:left-1/2 uipm:-translate-x-1/2 uipm:-mt-[1px]"
              width="12" 
              height="6" 
              viewBox="0 0 12 6" 
              fill="none"
            >
              <path d="M6 6L0 0H12L6 6Z" fill="#2C2C2C"/>
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};